<template>
  <div class="auction-card" :class="{ 'card-closed': auction.status !== auctionRowStatus.ONGOING }">
    <div class="card-header">
      <div class="header-left">
        <span class="auction-id">Չափաբաժին #{{ auction.num }} • {{ auction.qty }} {{ auction.unit }}</span>
        <span class="item-name">
          {{ auction.code }} - {{ auction.name }}
        </span>
      </div>
      <div :class="['status-badge', auctionStatusInfo[auction.status].class]">
        <span v-if="auction.status === auctionRowStatus.ONGOING" class="pulse"></span>
        {{ auctionStatusInfo[auction.status].label }}
      </div>
    </div>

    <div class="card-body">
      <div class="price-section">
        <div class="price-card current-wrapper">
          <div class="price-label">Ընթացիկ նվազագույն գին</div>
          <div class="current-price">
            {{ formatPrice(auction.price) }}

            <div class="per-item-price">
              {{ formatPrice(auction.price / auction.qty) }}
              դր
            </div>
          </div>
        </div>

        <div class="price-card my-bid-wrapper" :class="{'is-my': auction.isMy}">
          <div class="my-bid-info" v-if="auction.lastMyBid">
            <div class="bid-text-info">
              <span v-if="auction.isMy">Իմ առաջարկը</span>
              <span v-else>Իմ առաջարկը</span>
            </div>
            <div class="my-price" >
              {{ formatPrice(auction.lastMyBid) }}
            </div>

            <div class="per-item-price">
              {{ formatPrice(auction.lastMyBid / auction.qty) }}
              դր
            </div>
          </div>
          <div class="no-my-bid" v-else>Առաջարկված գին դեռևս չկա</div>
        </div>
      </div>

      <div class="info-group">
        <div class="info-row">
          <div class="info-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.6514 14.2671H5.13379V13.2007H12.6514V14.2671ZM9.06641 2.53369L8.59961 3.00049L12.5322 6.8667L12.999 6.3999L13.7324 7.1333L10.2656 10.6001L9.53223 9.8667L9.99902 9.3999L8.39941 7.80029L2.99902 13.1997L2.26562 12.4663L7.66602 7.06689L6.06641 5.53369L5.59961 6.00049L4.86621 5.26709L8.33301 1.73389L9.06641 2.53369ZM6.7998 4.73389L10.7324 8.6001L11.7324 7.6001L7.86621 3.73389L6.7998 4.73389Z" fill="#40444D"/>
            </svg>
            <span>{{ auction.bid_qty }} առաջարկներ</span>
          </div>

          <div class="info-item blue-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.99497 1.66663C4.49897 1.66663 1.66797 4.50396 1.66797 7.99996C1.66797 11.496 4.49897 14.3333 7.99497 14.3333C11.4973 14.3333 14.3346 11.496 14.3346 7.99996C14.3346 4.50396 11.4973 1.66663 7.99497 1.66663ZM8.0013 13.0666C5.20197 13.0666 2.93464 10.7993 2.93464 7.99996C2.93464 5.20063 5.20197 2.93329 8.0013 2.93329C10.8006 2.93329 13.068 5.20063 13.068 7.99996C13.068 10.7993 10.8006 13.0666 8.0013 13.0666ZM8.31797 4.83329H7.36797V8.63329L10.693 10.6283L11.168 9.84929L8.31797 8.15829V4.83329Z" fill="#006BE6"/>
            </svg>
            <span :class="{ urgent: timeLeft.urgent }">{{ timeLeft.text }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.6439 9.34995L9.34961 13.6399C9.23524 13.7563 9.09832 13.8482 8.94721 13.9099C8.72675 13.9996 8.48459 14.0218 8.25148 13.9737C8.01837 13.9257 7.80481 13.8095 7.6379 13.6399L2.3406 8.34195C2.22862 8.2357 2.14058 8.10684 2.08235 7.96395C2.02208 7.8174 1.99146 7.66038 1.99226 7.50195V3.19995C1.99055 3.04226 2.02109 2.88588 2.08203 2.74041C2.14296 2.59493 2.233 2.46343 2.34661 2.35395C2.4562 2.24044 2.58784 2.1505 2.73346 2.08963C2.87908 2.02876 3.03561 1.99824 3.19346 1.99995H7.50577C7.66494 1.99937 7.82247 2.03208 7.96823 2.09595C8.11361 2.15903 8.24599 2.24855 8.35862 2.35995L13.6439 7.65195C13.7611 7.76678 13.8513 7.90612 13.9082 8.05995C13.9621 8.20394 13.9906 8.35621 13.9923 8.50995C13.9911 8.66179 13.9626 8.81218 13.9082 8.95395C13.8496 9.10339 13.7595 9.23846 13.6439 9.34995ZM8.49676 12.7999L12.8031 8.50995L7.48775 3.19995H3.19346V7.48995L8.49676 12.7999ZM5.36162 6.26661C5.60056 6.26661 5.82971 6.17179 5.99866 6.00301C6.16761 5.83423 6.26253 5.60531 6.26253 5.36661C6.26253 5.12792 6.16761 4.899 5.99866 4.73022C5.82971 4.56143 5.60056 4.46661 5.36162 4.46661C5.12269 4.46661 4.89354 4.56143 4.72459 4.73022C4.55564 4.899 4.46072 5.12792 4.46072 5.36661C4.46072 5.60531 4.55564 5.83423 4.72459 6.00301C4.89354 6.17179 5.12269 6.26661 5.36162 6.26661Z" fill="#40444D"/>
            </svg>
            <span>{{ formatPrice(auction.estimated_price) }} Նախահաշվային արժեք</span>
          </div>

          <div class="info-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.0013 2.66663C3.71464 2.66663 2.66797 3.71329 2.66797 4.99996C2.66797 6.28663 3.71464 7.33329 5.0013 7.33329C6.28797 7.33329 7.33464 6.28663 7.33464 4.99996C7.33464 3.71329 6.28797 2.66663 5.0013 2.66663ZM5.0013 5.99996C4.44797 5.99996 4.0013 5.55329 4.0013 4.99996C4.0013 4.44663 4.44797 3.99996 5.0013 3.99996C5.55464 3.99996 6.0013 4.44663 6.0013 4.99996C6.0013 5.55329 5.55464 5.99996 5.0013 5.99996ZM11.0013 8.66663C9.71464 8.66663 8.66797 9.71329 8.66797 11C8.66797 12.2866 9.71464 13.3333 11.0013 13.3333C12.288 13.3333 13.3346 12.2866 13.3346 11C13.3346 9.71329 12.288 8.66663 11.0013 8.66663ZM11.0013 12C10.448 12 10.0013 11.5533 10.0013 11C10.0013 10.4466 10.448 9.99996 11.0013 9.99996C11.5546 9.99996 12.0013 10.4466 12.0013 11C12.0013 11.5533 11.5546 12 11.0013 12ZM3.60797 13.3333L2.66797 12.3933L12.3946 2.66663L13.3346 3.60663L3.60797 13.3333Z" fill="#40444D"/>
            </svg>
            <span>{{ Math.round((auction.price / auction.estimated_price) * 100) }} Տարբերություն</span>
          </div>
        </div>
      </div>

      <div v-if="!mainAuction.isViewer && auction.status === auctionRowStatus.ONGOING" class="bid-form">
        <div class="bid-input-wrapper">
          <div class="bid-input">
            {{ formattedBidAmount }}
          </div>
          <div class="per-item-price">
            {{ formatPrice(bidAmount / auction.qty) }}
          </div>
          <div class="bid-manage-button-wrap">
            <button
                class="bid-manage-button increase-bid-button"
                type="button"
                title="Set minimum bid amount"
                @click="prevBidPrice"
                v-if="isValidBid"
            >
              <i class="fas fa-arrow-up"></i>
            </button>
            <button
                class="bid-manage-button decrease-bid-button"
                type="button"
                title="Set minimum  bid amount"
                @click="nextBidPrice"
            >
              <i class="fas fa-arrow-down"></i>
            </button>
          </div>

        </div>
        <button
            @click="handleBid"
            class="bid-button"
            :disabled="!isValidBid"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.9775 21.3999H7.7002V19.8003H18.9775V21.3999ZM13.5986 3.80029L12.8984 4.50049L18.7988 10.3003L19.498 9.6001L20.5986 10.6997L15.3984 15.8999L14.2988 14.8003L14.998 14.1001L12.5986 11.6997L4.49805 19.8003L3.39844 18.6997L11.498 10.6001L9.09863 8.30029L8.39844 9.00049L7.29883 7.8999L12.498 2.6001L13.5986 3.80029ZM10.1982 7.1001L16.0986 12.8999L17.5986 11.3999L11.7988 5.6001L10.1982 7.1001Z" fill="white"/>
          </svg>
          Առաջարկել
        </button>
      </div>

      <div v-if="!mainAuction.isViewer && auction.status === auctionRowStatus.ONGOING && inpHelpInfo" class="help-info">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.51995 11.7034L7.15328 1.97671C7.23819 1.82698 7.36129 1.70245 7.51003 1.61581C7.65876 1.52917 7.82782 1.48352 7.99995 1.48352C8.17208 1.48352 8.34113 1.52917 8.48987 1.61581C8.6386 1.70245 8.7617 1.82698 8.84661 1.97671L14.4799 11.7034C14.5667 11.8523 14.6127 12.0215 14.6132 12.1938C14.6137 12.3661 14.5687 12.5356 14.4829 12.685C14.397 12.8344 14.2732 12.9586 14.1241 13.0449C13.9749 13.1312 13.8056 13.1767 13.6333 13.1767H2.36661C2.19427 13.1767 2.02498 13.1312 1.87582 13.0449C1.72665 12.9586 1.6029 12.8344 1.51703 12.685C1.43116 12.5356 1.38621 12.3661 1.38672 12.1938C1.38724 12.0215 1.43319 11.8523 1.51995 11.7034ZM8.47328 10.9834C8.58275 10.8748 8.6512 10.7316 8.66697 10.5782C8.68274 10.4249 8.64486 10.2708 8.55978 10.1422C8.47469 10.0136 8.34767 9.91847 8.20033 9.87302C8.05299 9.82757 7.89446 9.83459 7.75172 9.89289C7.60898 9.95119 7.49086 10.0572 7.41748 10.1928C7.3441 10.3284 7.31999 10.4852 7.34926 10.6366C7.37853 10.788 7.45937 10.9246 7.57801 11.023C7.69665 11.1215 7.84576 11.1758 7.99995 11.1767C8.08768 11.1772 8.17466 11.1604 8.25588 11.1272C8.33711 11.0941 8.41099 11.0452 8.47328 10.9834ZM7.33328 9.17671H8.66661V5.84338H7.33328V9.17671Z" fill="#E02232"/>
        </svg>
        <div class="help-info-txt">
          {{ inpHelpInfo }}
        </div>
      </div>
      <div v-if="auction.status !== auctionRowStatus.ONGOING || mainAuction.isViewer" class="closed-message">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.25C8.26942 1.25 6.57769 1.76318 5.13876 2.72464C3.69983 3.6861 2.57832 5.05267 1.91606 6.65152C1.25379 8.25037 1.08051 10.0097 1.41813 11.707C1.75575 13.4044 2.58911 14.9635 3.81282 16.1872C5.03653 17.4109 6.59563 18.2443 8.29296 18.5819C9.9903 18.9195 11.7496 18.7462 13.3485 18.0839C14.9473 17.4217 16.3139 16.3002 17.2754 14.8612C18.2368 13.4223 18.75 11.7306 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM17.0833 10C17.0798 11.5426 16.5704 13.0414 15.6333 14.2667L5.73334 4.36667C6.78168 3.56774 8.03256 3.07794 9.34466 2.95259C10.6567 2.82724 11.9777 3.07136 13.1584 3.65734C14.339 4.24333 15.3323 5.14783 16.0258 6.26866C16.7194 7.38948 17.0857 8.68194 17.0833 10ZM2.91667 10C2.92021 8.45745 3.42957 6.95862 4.36667 5.73333L14.2667 15.6333C13.2183 16.4323 11.9674 16.9221 10.6554 17.0474C9.34326 17.1728 8.02226 16.9286 6.84162 16.3427C5.66098 15.7567 4.66775 14.8522 3.97417 13.7313C3.28058 12.6105 2.91429 11.3181 2.91667 10Z" fill="#ABAEB8"/>
        </svg>
        {{ auctionStatusInfo[auction.status].detailed_label }}
      </div>
    </div>
  </div>
</template>

<script>

import auction from "@/mixins/auction";

export default {
  name: 'AuctionCard',
  mixins: [auction],
  props: {
    auction: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bidAmount: null,
      timerInterval: null,
      timeLeft: { text: 'Հաշվարկվում է ...', urgent: false },
      inpHelpInfo: null,
      duration: null,
      timerUpdateInterval: 1000, // milliseconds
    }
  },
  watch: {
    auction: {
      handler(newAuction) {
        this.bidAmount = this.bidAmount > newAuction?.price ? newAuction?.price : this.bidAmount;

        if (this.timerInterval) {
          clearInterval(this.timerInterval)
        }
        this.duration = this.auction.duration
        this.timerInterval = setInterval(this.updateTimer.bind(this), this.timerUpdateInterval)
      },
      immediate: true
    },
    bidAmount: {
      handler(newVal) {
        this.inpHelpInfo = (newVal / this.auction.estimated_price) < 0.75 ? 'Ձեր ներկայացրած գինը նախահաշվային արժեքից ցածր է ավելի քան 25%-ով։' : null
      },
      immediate: true
    }
  },
  computed: {
    minBidPercent() {
      return this.$store.getters['auction/auction'].step
    },
    isValidBid() {
      if (!this.bidAmount || isNaN(this.bidAmount)) return false
      return this.auction.price > this.bidAmount && this.auction.status === this.auctionRowStatus.ONGOING
    },
    formattedBidAmount() {
      return this.bidAmount != null
        ? Number(this.bidAmount).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
        : '';
    },
    mainAuction() {
      return this.$store.getters['auction/auction']
    }
  },
  mounted() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
    this.updateTimer()
    this.timerInterval = setInterval(this.updateTimer, this.timerUpdateInterval)
    this.bidAmount = this.bidAmount && this.auction.price > this.bidAmount ? this.bidAmount : this.auction.price
    this.duration = this.auction.duration
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval)
  },
  methods: {
    prevBidPrice() {
      this.bidAmount = this.prevBidAmount()
    },
    nextBidPrice() {
      this.bidAmount = this.nextBidAmount()
    },
    prevBidAmount() {
      return this.bidAmount / (1 - this.minBidPercent / 100);
    },
    nextBidAmount() {
      return this.bidAmount * (1 - this.minBidPercent / 100)
    },
    formatPrice(price) {
      return Number(price).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },
    updateTimer() {
      if (this.auction.status === this.auctionRowStatus.COMPLETED) {
        this.timeLeft = { text: 'Ավարտվել է', urgent: false }
        if (this.timerInterval) clearInterval(this.timerInterval)
        return
      }
      if (this.auction.status === this.auctionRowStatus.PENDING) {
        this.timeLeft = { text: '-', urgent: false }
        if (this.timerInterval) clearInterval(this.timerInterval)
        return
      }

      const mins = Math.floor(this.duration / 60000)
      const secs = Math.floor((this.duration % 60000) / 1000)
      this.timeLeft = {
        text: `${mins} Ր ${secs} Վրկ`,
        urgent: mins < 1
      }

      this.duration = this.duration - this.timerUpdateInterval
    },
    handleBid() {
      if (!this.isValidBid) return

      const bidValue = this.bidAmount

      this.$emit('bid', {
        auctionRowId: this.auction.id,
        amount: bidValue,
      })
    }
  }
}
</script>
